var globalStore;
export function setGlobalStore(store) {
    if (globalStore !== undefined && store !== undefined) {
        console.warn("A global store is already defined. Call 'removeGlobalStore()' to remove the currently registered store. You can ignore this error if it is triggered by HMR.");
    }
    globalStore = store;
}
export function removeGlobalStore() {
    globalStore = undefined;
}
export function getGlobalStore() {
    if (globalStore === undefined) {
        throw new Error("no global store registered");
    }
    return globalStore;
}
